import { useFlag } from 'utils/launchdarkly';

import { Pypestream } from './pypestream';

export { PYPESTREAM_INTERFACE_ID, PYPESTREAM_SCRIPT_ID } from '../../state/pypestream/constants';

export const PypestreamWrapper = () => {
  const enablePypestream = useFlag('enable-pypestream');

  if (!enablePypestream) {
    return null;
  }

  return <Pypestream />;
};
